import { createFileRoute } from '@tanstack/react-router'
import { OrderDetailView } from '@/features/orders/components/order-detail'

// Same order screen the backroom uses, wearing the accounting desk's
// buttons: factor instead of gathering, hand-over instead of status.
function AccountingOrderDetailPage() {
  const { orderId } = Route.useParams()

  return <OrderDetailView orderId={orderId} mode='accounting' />
}

export const Route = createFileRoute('/_authenticated/accounting-orders/$orderId')({
  component: AccountingOrderDetailPage,
})
